<div (tunResize)="onResize($event)" class="music-bars">
    <canvas #simplePlayAnimationCanvas class="playAnimation"></canvas>
</div>

